'use strict';

export default function useGetBrowserLanguage() {
    const browserLanguage = navigator.language;

    let language;
    if (browserLanguage) {
        language = _.find(RivalIQ.metrics.new.enums.ListeningLanguages, {
            isoCode: browserLanguage
        });

        if (!language) {
            language = _.find(RivalIQ.metrics.new.enums.ListeningLanguages, {
                isoCode: browserLanguage.substring(0, 2)
            });
        }
    }

    // NOTE there are only a handful of languages that can be defaults, so even
    // if we find the language of the browser it may not be eligible for use
    if (!language || !language.isDefault) {
        // NOTE this will default to ALL in a multi-select
        return null;
    }

    return language.id;
}
